<template>
  <v-expansion-panels accordion multiple focusable hover tile>
    <v-expansion-panel v-for="(frame, i) in frames" :key="i">
      <v-expansion-panel-header>
        <div class="h-row">
          <div class="grow-0" style="width: 150px">
            Frame {{ (i + 1) | pad(2) }}: {{ frame.type }}
          </div>
          <div style="width: 120px" class="text-right pr-6">
            ({{ frame.length }} bytes)
          </div>
          <div>
            {{ frame | shortDesc }}
          </div>
          <v-spacer />
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="noPaddingExpansionPanel">
        <LapseTable :value="frame.payload" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <!-- <v-simple-table v-if="data != null">
    <tbody v-for="(f,i) in data.frames" :key="i">
      <tr>
        <th colspan="3" class="text-xs-left">
          {{f.type | capitalize}} Frame: {{f.startIndex}}-{{f.endIndex}}
          ({{f.length}} bytes)
        </th>
      </tr>

      <tr v-if="f.type == 'garbage'">
        <td>
          {{f.type}} <br>
          bytes {{f.startIndex}}-{{f.endIndex}}
        </td>
        <td class="fixed-width rawdata-bg">{{f.bytes | prettyHex}}</td>
        <td class="fixed-width">-</td>
      </tr>

      <tr v-else-if="f.type == 'lapses'" v-for="(l, idx) in f.lapses" :key="idx">
        <td>
          {{l.type | capitalize}} lapse #{{idx}} <br>
          bytes {{l.startIndex}}-{{l.endIndex}}
        </td>
        <td class="fixed-width rawdata-bg">{{l.bytes | prettyHex}}</td>
        <td class="fixed-width">{{l | strLapse}}</td>
      </tr>

      <tr v-else>
        <td>
          {{f.type}} <br>
          bytes {{f.startIndex}}-{{f.endIndex}}
        </td>
        <td class="fixed-width rawdata-bg">{{f.bytes | prettyHex}}</td>
        <td class="fixed-width">{{f.header || f.footer || f.event | strLapse}}</td>
      </tr>

    </tbody>
  </v-simple-table> -->

  <!-- <pre v-if="data != null">startedAt   : {{data.startedAt}}
stoppedAt   : {{data.stoppedAt}}
remaining   : {{data.remaining}}
bufferLength: {{data.bufferLength}}</pre> -->
</template>

<script>
import _ from 'lodash'
import { dt } from 'oderon-commons/src/formatters'

export default {
  components: {
    LapseTable: require('../heartbeats/LapseTable').default
  },
  props: ['data'],
  computed: {
    frames() {
      return this.data.frames
    }
  },
  filters: {
    pad(x, n) {
      return _.padStart(x, n, '0')
    },

    shortDesc(f) {
      if (f.type == 'header') {
        return `${dt(f.header.timestamp)} ─ ${f.header.driverId}`
      } else if (f.type == 'footer') {
        return `${dt(f.footer.timestamp)}`
      } else if (f.type == 'event') {
        return `${dt(f.event.timestamp)} ─ ${f.event.operationType} ${f.event
          .log || ''}`
      } else if (f.type == 'lapses') {
        let incOdos = _.filter(f.lapses, { incOdo: 1 }).length
        return `${f.lapses.length} lapses, ${incOdos} incOdos`
      }
    }

    // prettyHex(bytes) {
    //   if ( bytes == null ) return ''
    //   return brush.toHex(bytes, {
    //     prettyPrint: true, bytesPerLine: 16
    //   })
    // },
    // strLapse(lapse) {
    //   if ( lapse == null ) return ''

    //   let lines = _.reduce(lapse, (acc, val, key) => {
    //     if ( val == null || key == 'startIndex' ||
    //          key == 'endIndex' || key == 'bytes' || key == 'type' ) return acc
    //     if ( _.isArray(val) ) val = `[${val.join(',')}]`
    //     if ( _.isDate(val) || moment.isMoment(val) )
    //       val = moment(val).format()

    //     acc.push(`${key}=${val.toString()}`)
    //     return acc
    //   }, [])

    //   return lines.sort().join('\n')
    // },
    // capitalize(s) {
    //   return _.capitalize(s)
    // }
  }
}
</script>

<style>
.rawdata-bg {
  background-color: #f5f5f5;
}
</style>
